import React from 'react'

const Pagination = props => {
  //const { type, step } = useParams();
  return <div className="flex justify-center items-center mb-11 mt-4 2xl:mt-20">
    {props.data.map((el, index) => <div onClick={() => { props.onClick(el,index) }} className={`border rounded-full mx-10 w-7 h-7 flex justify-center items-center pointer-events-none ${index <= props.active - 1 ? 'border-primary pointer-events-auto cursor-pointer' : 'border-primary-light'}`} to={`${index + 1}`} key={index}>
      {index === props.active - 1 ? <span className="flex rounded-full w-4.5 h-4.5 bg-primary"></span> : ""}
    </div>)}
  </div>
}

export default Pagination
